export function getCurrentDomainFolder(skipDev = false) {
  const currentUrl = new URL(window.location.href);
  const { hostname } = currentUrl;
  const { protocol } = currentUrl;
  const pathSegments = currentUrl.pathname.split('/').filter((segment) => segment.length > 0);

  const availableFolders = [
    '18-plus-companion-clones',
    'ai-and-the-epidemic-of-loneliness',
    'ai-companions',
    'ai-guide',
    'ais-human-touch-augmenting-emotional-intelligence',
    'article',
    'ashley',
    'ashleys-message-creator',
    'auth',
    'blog',
    'blair',
    'blairs-message-creator',
    'category',
    'chatbots',
    'cloneme-io-pioneering-the-next-wave-of-ai-at-mits-imagination-in-action-conference',
    'clonemes-human-centred-design-approach-to-digitaldna-twins',
    'companion-clones-demo',
    'companion-clones-demo-old',
    'companions',
    'creator-dashboard',
    'dev-companion-clones',
    'dev-luminaries',
    'digital-twin-checkout',
    'digital-twin-confirmation-page',
    'ensuring-ethical-ai-practices-in-digital-clones-empowering-individuals-to-safeguard-their-image-and-likeness',
    'ethics',
    'features',
    'home-casey-pop',
    'hyper-specialized-motivational-clones',
    'hyper-specialized-clones',
    'test-hyper-specialized-clones',
    'iframe-specialized-clones',
    'influencer',
    'influencer-sign-up',
    'influencers',
    'innovations',
    'insights',
    'interaction-sty',
    'luminaries',
    'luminaries-old',
    'machine-learning-unveiled-journey-into-algorithms-and-techniques',
    'master-class-clones',
    'meet-chloe-the-ultimate-ai-companion',
    'modals',
    'news',
    'nikki',
    'nikkis-message-creator',
    'northpole',
    'northpole-checkout-page',
    'northpole-message-creator-elf',
    'northpole-message-creator-mrs-claus',
    'northpole-message-creator-santa',
    'North Pole - Confirmation Page',
    'payments',
    'pop-test',
    'pricing',
    'pricing-features',
    'privacy-policy',
    'profile',
    'specialized-companion-clones',
    'specialized-clones',
    'specialized-health-and-fitness-clones',
    'sidney-brisbane',
    'spotlight',
    'staging-companion-clones-demos',
    'support',
    'team-clones',
    'temp',
    'terms-of-service',
    'unveiling-the-ethical-imperative-navigating-bias-privacy-and-transparency-in-ai',
    'ai-business-advisor',
    'pricing-ai-advisor',
    'james-oglethorpe',
  ];

  // Check if the first segment of the path is 'dev'
  const firstFolder =
    pathSegments.length > 0 && !availableFolders.includes(pathSegments[0]) && !skipDev
      ? `/${pathSegments[0]}`
      : '';

  // Construct the desired URL string
  const resultUrl = `${protocol}//${hostname}${firstFolder}`;
  return resultUrl;
}

export function handleFormSubmit(
  formElement: HTMLFormElement,
  submitFunction: () => Promise<boolean>
): void {
  const successMessage: HTMLElement = formElement.querySelector('[data-form-status="success"]');
  const errorMessage: HTMLElement = formElement.querySelector('[data-form-status="error"]');
  const formArea: HTMLElement = formElement.querySelector('[data-form-status="base"]');
  const submitButton: HTMLButtonElement = formElement.querySelector('[type="submit"]');

  formElement.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (submitButton) submitButton.disabled = true;
    try {
      const success = await submitFunction();
      if (success) {
        if (successMessage) successMessage.style.display = 'block';
        if (formArea) formArea.style.display = 'none';
        if (submitButton) submitButton.disabled = false;
      } else {
        if (errorMessage) errorMessage.style.display = 'block';
        if (submitButton) submitButton.disabled = false;
      }
    } catch (error) {
      if (errorMessage) errorMessage.style.display = 'block';
      if (submitButton) submitButton.disabled = false;
    }
  });
}
